module.exports = __webpack_public_path__ + "static/img/angular-js.594101c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/angular-js.jpg
// module id = Szhw
// module chunks = 0